export function formatRawPhone(phone: string): string {
  return phone.startsWith('+') ? phone : `+${phone}`;
}
